<template>
  <app-form class="marketing-sms-form-content"
            @submit="advanceStep">
    <section class="marketing-sms-form-content-inpt">
      <v-text-field v-if="isEdit"
                    v-model="title"
                    v-validate="'required|min:2'"
                    class="marketing-sms-form-content-inpt-title"
                    :label="$t('message.marketingGenerics.message.title')"
                    name="Título"
                    :disabled="view"
                    :counter="50"
                    :error-messages="errors.collect($t('message.marketingGenerics.message.title'))"></v-text-field>
      <app-textarea v-model="content"
                    :validate="`required|min:2|max:${contentCounter}`"
                    :disabled="view"
                    :error-messages="errors.collect($t('message.marketingGenerics.message.message'))"
                    :counter="contentCounter"
                    :help="$t('message.marketingGenerics.message.messageHint')"
                    class="marketing-sms-form-content-text"
                    outlined
                    :label="$t('message.marketingGenerics.message.message')"
                    name="Mensagem">
        <template #header-right>
          <dropdown class="marketing-sms-form-content-text-variable"
                    data-icon="mdi-code-braces">
            <p class="marketing-sms-form-content-text-variable-help">
              {{ $t('message.marketingGenerics.message.tooltipFirstName') }}</p>
            <p class="marketing-sms-form-content-text-variable-options">{PRIMEIRO_NOME}</p>
          </dropdown>
        </template>
      </app-textarea>
      <div class="counter-wrapper">
        <span>{{ charactersUsed }} / {{ customCounter }}</span>
      </div>
    </section>

    <div class="marketing-sms-form-actions">
      <button v-if="!view"
              type="button"
              class="btn btn-round marketing-sms-form-actions-save btn-stretch"
              @click="emitSendDraft">
        {{ $t('message.marketingGenerics.message.saveDraft') }}
      </button>
      <button type="submit"
              class="btn btn-round btn-primary btn-stretch">
        {{ $t('message.generics.message.advance') }}
      </button>
    </div>
  </app-form>
</template>

<script>
import Dropdown from "@components/Dropdown";
import AppTextarea from "@components/form/Textarea.vue";
import AppForm from "@components/form/Form.vue";

export default {
  components: {
    AppForm,
    AppTextarea,

    Dropdown,
  },

  data() {
    return {
      content: "",
      title: "",
    };
  },

  props: {
    initialData: {
      type: Object,
      required: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    view: {
      type: Boolean,
      required: false,
    },
  },

  methods: {    
    async advanceStep() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.$emit("advance", { content: this.content, title: this.title });
      }
    },
    async emitSendDraft() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.$emit("saveDraft", { content: this.content, title: this.title });
      }
    },    
  },

  created() {
    if (this.initialData) {
      this.title = this.initialData.title;
      this.content = this.initialData.content;
    } else {
      this.title = this.initialData.title;
    }
  },

  computed: {
    contentCounter() {
      let regex = /^[A-Za-z0-9 ,.]+$/
      // let charactersAdded = 0
      if (!this.content) {
        return 140;
      }
      if(this.content.includes('{PRIMEIRO_NOME}')) {
        regex = /^[A-Za-z0-9 ,._{}]+$/
      }
      return regex.test(this.content) ? 140 : 70;
      
    },
    customCounter() {
      let regex = /^[A-Za-z0-9 ,.]+$/
      if (!this.content) {
        return 140;
      }
      if(this.content.includes('{PRIMEIRO_NOME}')) {
        regex = /^[A-Za-z0-9 ,._{}]+$/
      }
      return regex.test(this.content) ? 140 : 70;
    },
    charactersUsed() {
      const regexFirstName = /{PRIMEIRO_NOME}/g;
      let ocorrenciasNome = 0
      if(regexFirstName.test(this.content)) {
        ocorrenciasNome = this.content.match(regexFirstName).length
      }
      return this.content ? this.content.length - ocorrenciasNome : 0
    }
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
.marketing-sms-form-content {
  .marketing-sms-form-content-inpt {
    margin-bottom: 20px;

    .marketing-sms-form-content-inpt-title {
      margin-bottom: 20px !important;
    }

    .counter-wrapper {
      display: flex;
      justify-content: flex-end;
      position: relative;
     bottom: 24px;
     right: 35px;
     font-size: 12px;
     color: rgb(196, 196, 196);
    }
  }

  .marketing-sms-form-content-text {
    .marketing-sms-form-content-text-variable {
      font-size: 12px;
      margin-bottom: 5px;

      ::v-deep .dropdown-btn {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        padding: 0;
        display: flex;
        justify-content: center;
      }

      ::v-deep .dropdown-icon {
        font-size: 14px;
        margin: 0;
        height: 20px;
      }

      .marketing-sms-form-content-text-variable-help {
        margin-bottom: 10px;
      }

      .marketing-sms-form-content-text-variable-options {
        margin: 0;
      }
    }
  }

  .marketing-sms-form-actions {
    display: flex;
    justify-content: center;

    .marketing-sms-form-actions-save {
      border: 1px solid gray;
      margin-right: 50px;
    }
  }
}
</style>
